/**
 * F10 (Optimierung 2026-08-25): Download-Adressen mit Query-Parametern — der
 * URLSearchParams-Bau stand in vier Seiten in vier verschiedenen Idiomen
 * (IIFE, Template-String, Object.entries-Filter, eigene Funktion).
 */
export function apiHref(path: string, params: Record<string, string | undefined>): string {
  const p = new URLSearchParams();
  for (const [k, v] of Object.entries(params)) {
    if (v !== undefined && v !== '') p.set(k, v);
  }
  const s = p.toString();
  return s ? `${path}?${s}` : path;
}
